import React, { Component } from 'react';
import EnhancedTable from '../../components/dataTable'
import { Card, CardHeader, CardBody } from 'reactstrap'
import exportlistImg from '../../../src/assets/fontawesome/csv.png'
import { Link } from 'react-router-dom';

import ClipLoader from 'react-spinners/ClipLoader'
import Modal from 'react-modal'
import { Helmet } from "react-helmet";
import AppContext from '../../AppContext';
// import DownloadIcon from '../../../public/img/download.png';
// import LinkIcon from '../../../public/img/link.png';
import { cities, _location, industry } from '../../common/const';
// import Lead411Ad from '../../components/adBlock'
const env = process.env.NODE_ENV || 'development';
const config = require('../../config.json')[env];
const main_server = config.main_server
// const fileDownload = require('js-file-download');
import Select from 'react-select'
import Cookies from 'js-cookie';
import SweetAlert from 'react-bootstrap-sweetalert';
import Postman from '../../utils/service'

// images
import review from '../../assets/img/welcome/review.png';
import userLove from '../../assets/img/welcome/userLove.png';

let States = []
let skipStates = ['American Samoa', 'Federated States Of Micronesia', 'Guam', 'Marshall Islands', 'Northern Mariana Islands',
  'Virgin Islands', 'Palau', 'Puerto Rico']
Object.keys(_location).forEach(function (key) {
  if (skipStates.indexOf(_location[key]) < 0) {
    States.push({
      key: key,
      name: _location[key]
    })
  }

});


let dropdownArray = [
  {
    title: 'Growjo 1,000',
    key: 'all',
    type: 'All'
  }
];

let allGrowjoOptions = [{ value: (dropdownArray.length - 1), label: 'Growjo 1,000' }]

let stateOptions = []

States.map((state, index) => {
  dropdownArray.push({
    title: state.name,
    key: state.key,
    type: 'state'
  })
  stateOptions.push({ value: (dropdownArray.length - 1), label: state.name })

})


stateOptions.sort(function(a, b) {
  return a.label.localeCompare(b.label)
});

let citiesOptions = []

cities.map((city, index) => {
  dropdownArray.push({
    title: city,
    type: 'city'
  })
  citiesOptions.push({ value: (dropdownArray.length - 1), label: city })
})

citiesOptions.sort(function(a, b) {
  return a.label.localeCompare(b.label)
});

let industryOptions = [];

industry.map((industryName, index) => {
  dropdownArray.push({
    title: industryName,
    type: 'industry'
  })
  industryOptions.push({ value: (dropdownArray.length - 1), label: industryName })
})

industryOptions.sort(function(a, b) {
  return a.label.localeCompare(b.label)
});




const groupStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};
const groupBadgeStyles = {
  backgroundColor: '#EBECF0',
  borderRadius: '2em',
  color: '#172B4D',
  display: 'inline-block',
  fontSize: 12,
  fontWeight: 'normal',
  lineHeight: '1',
  minWidth: 1,
  padding: '0.16666666666667em 0.5em',
  textAlign: 'center',
};

const groupedOptions = [
  {
    label: 'Growjo 1,000 List',
    options: allGrowjoOptions,
  },
  {
    label: 'State',
    options: stateOptions,
  },
  {
    label: 'City',
    options: citiesOptions,
  },
  {
    label: 'Industry',
    options: industryOptions,
  },
];

const formatGroupLabel = data => (
  <div style={groupStyles}>
    <span>{data.label}</span>
    <span style={groupBadgeStyles}>{data.options.length}</span>
  </div>
);
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '350px',
    height: '200px',
    border: 0,
    padding: 33,
    borderRadius: 20
  },
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.4)'
  }
};

Modal.setAppElement('#root')

class Home extends Component {
  constructor(props) {
    super(props);

    if (!Cookies.get('token') && !Cookies.get('accessToken')) {
      if (typeof window !== "undefined") {
        window.location = '/logout';
      }
    }


    this.state = {
      modalIsOpen: false,
      state: null,
      country: null,
      page: 1,
      selectedCompany: '',
      downloadFilename: '',
      canDownloadFiles: this.props.auth.user.canDownloadFiles == 1 ? true : false,
      downloadExportListType: '',
      downloadExportListKey: '',
      downloadExportListName: '',
      showExportPopUp: false,
      remainingDownloadLimit: 0,
      showExportErrorPopUp: false,
      isPremiumUser: false,
    };
  }
  selectCompany = (company, id) => {

    this.props.history.push(`/company/${company}`);
  }

  download = () => {
    this.setState({ modalIsOpen: true })
    setTimeout(() => { this.setState({ modalIsOpen: false }) }, 5000);

    const link = document.createElement('a')
    link.setAttribute('href', `${main_server}/ExportList.csv`)
    link.setAttribute('download', 'ExportList.csv')
    document.body.appendChild(link)
    link.click()
  }

  downloadCSV = (file) => {
    this.setState({ downloadFilename: file }, () => {
      const link = document.getElementById('csv-download-btn')
      link.click()
    });
  }

  download_city = (city) => {
    this.setState({ modalIsOpen: true })
    setTimeout(() => { this.setState({ modalIsOpen: false }) }, 5000);

    const link = document.createElement('a')
    link.setAttribute('href', `${main_server}/ExportList.csv/${city}`)
    link.setAttribute('download', `ExportList_${city}.csv`)
    document.body.appendChild(link)
    link.click()
  }
  openModal = () => {
    this.setState({ modalIsOpen: true });
  }
  componentDidMount() {
    const { page } = this.props.match.params
    this.setState({ page })
    this.handleLoad()
  }

  componentWillReceiveProps(nextprops) {

  }

  afterOpenModal = () => {
  }

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  }

  downloadFromDropdown = () => {
    this.setState({ showExportPopUp: false })

    if (!this.state.selectedCompany || this.state.selectedCompany.value === '') return
    let data = dropdownArray[this.state.selectedCompany.value]

    this.setState(
      {
        downloadExportListKey: data.key,
        downloadExportListType: data.type,
        downloadExportListName: data.title
      }, () => {
        const link = document.getElementById('exportlist-download-btn')
        link.click()
      });
    return
    // if (data.type == 'All') {
    //   this.download()
    // } else if (data.type == 'city') {
    //   this.download_city(data.title)
    // } else {
    //   this.download_city(data.key)
    // }
  }

  checkMonthlyDownloadLimit = () => {
    let data = dropdownArray[this.state.selectedCompany.value]

    Postman.checkMonthlyDownloadLimit(this.props.filter)
      .then(res => {
        if(res.data.isPremiumUser){
          this.setState({ showExportPopUp: true, remainingDownloadLimit: res.data.remainingLimit, isPremiumUser: true})
        }
        else if (res.data.remainingLimit > 0) {
          let remLimit = 0;
          if (data.type == 'All') {
            remLimit = res.data.remainingLimit - 1000;
          } else {
            remLimit = res.data.remainingLimit - 100;
          }
          if (remLimit < 0) remLimit = 0;
          this.setState({ showExportPopUp: true, remainingDownloadLimit: remLimit })
        }
        else
          this.setState({ showExportErrorPopUp: true })

      })
      .catch(e => {
        console.log('e', e)
        // this.props.history.push('/join')
      });
  }

  closeExportPopUp = () => {
    this.setState({ showExportPopUp: false })
  }

  closeExportErrorPopUp = () => {
    this.setState({ showExportErrorPopUp: false })
  }

  upgradeBtn = () => {
    this.props.history.push(`/schedule-demo`);
  }

  handleChange = selectedOption => {
    this.setState(
      { selectedCompany: selectedOption }
    );
  };


 

  handleLoad = () => {

    setTimeout(() => {
      // this.setState({ showAd: true })
      if (document.getElementById("drift-chat") && !document.querySelector("#drift-chat script")) {

        const script = document.createElement("script");
        script.innerHTML = `
        "use strict";

          !function() {
            var t = window.driftt = window.drift = window.driftt || [];
            if (!t.init) {
              if (t.invoked) return void (window.console && console.error && console.error("Drift snippet included twice."));
              t.invoked = !0, t.methods = [ "identify", "config", "track", "reset", "debug", "show", "ping", "page", "hide", "off", "on" ], 
              t.factory = function(e) {
                return function() {
                  var n = Array.prototype.slice.call(arguments);
                  return n.unshift(e), t.push(n), t;
                };
              }, t.methods.forEach(function(e) {
                t[e] = t.factory(e);
              }), t.load = function(t) {
                var e = 3e5, n = Math.ceil(new Date() / e) * e, o = document.createElement("script");
                o.type = "text/javascript", o.async = !0, o.crossorigin = "anonymous", o.src = "https://js.driftt.com/include/" + n + "/" + t + ".js";
                var i = document.getElementsByTagName("script")[0];
                i.parentNode.insertBefore(o, i);
              };
            }
          }();
          drift.SNIPPET_VERSION = '0.3.1';
          drift.load('akvsgt4rgdgb');
          `;
        script.language = 'javascript';
        document.getElementById("drift-chat").innerHTML = "";
        document.getElementById("drift-chat").appendChild(script)
      }
    }, 5000)

  }
  
  render() {
    const header = "Download one of our awesome free lists:"
    const title = 'Welcome to Growjo'

    const premiumListData = [
      {
        name: 'Top 10,000 Fastest Growing',
        description: 'Top 10,000 fastest growing companies including funding info, employee ct, revenue info, etc',
        count: '10,000',
        amount: '$1,000',
        paymentLink: 'https://buy.stripe.com/4gw6oOeyY6Ht0Fy7sx'
      },
      {
        name: 'Top 6,000 Fintech Companies',
        description: 'Top fintech companies that includes sub category like crypto, blockchain, etc',
        count: '6,000',
        amount: '$1,000',
        paymentLink: 'https://buy.stripe.com/6oEbJ88aA5DpgEwaEF'
      },
      {
        name: 'Top 16,000 Funded Companies',
        description: 'Includes total funding, revenue info, etc',
        count: '16,000',
        amount: '$1,000',
        paymentLink: 'https://buy.stripe.com/3cscNcfD24zlewo7su'
      },
      {
        name: 'Top 4800 Silicon Valley Co\'s',
        description: 'Includes total funding, revenue info, etc',
        count: '4,800',
        amount: '$800',
        paymentLink: 'https://buy.stripe.com/eVabJ84Yoe9V1JC5kn'
      },
      {
        name: 'Top 11,000 NYC Companies',
        description: 'Includes total funding, revenue info, etc',
        count: '11,000',
        amount: '$800',
        paymentLink: 'https://buy.stripe.com/6oE3cCeyYd5R73WbIM'
      },
    ]
    // const tableData = this.context.data?this.context.data:[]

    const downloadConfirmationMsg = this.state.isPremiumUser ? 
      `Want to export all below companies?`:
      `After downloading this, the remaining monthly download limit will become ${this.state.remainingDownloadLimit}, want to continue?`;

    return (
      <div className="animated fadeIn" style={{ height: "100%" }}>
        <Helmet>
          <title>{title}</title>
          <meta name="description" content={title} />
          <meta name="author" content="Growjo" />
          <meta name="robots" content="noindex" />
        </Helmet>
        <Card style={{ height: '100%', marginBottom: 0, border: 0 }}>
          <CardHeader className='d-flex justify-content-between align-items-center' style={{ backgroundColor: 'white' }}>
            <div>
              <h1 className='welcomeHead' style={{ color: '#000', fontSize: 75, fontWeight: 'bold', margin: 0 }}>Welcome to Growjo!</h1>
              <h1 className='welcomeSub' style={{ color: ' #8083A3', fontSize: 24, margin: 0, marginTop: 10, fontWeight: 500}}>{header}</h1>
            </div>
            <div className='download' onClick={this.download} >
              <span>Free Download</span>
              <img src={exportlistImg} />
            </div>
            <div>
            <img src={userLove} />
               <img src={review} />
               
            </div>
          </CardHeader>
          <CardBody>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              <div className="col-md-6">
                {this.state.canDownloadFiles &&
                  <div className="row">
                    <div className="col-md-6 dwnld-link" onClick={() => this.downloadCSV('all_companies')} >
                      <h4 style={{ cursor: "pointer", fontSize:16,fontWeight:500,letterSpacing:'2px',lineHeight: '32px' }}>Download all Companies <img src={exportlistImg} /></h4>
                    </div>
                    <div className="col-md-6 dwnld-link" onClick={() => this.downloadCSV('US_companies')} >
                      <h4 style={{ cursor: "pointer", fontSize:16,fontWeight:500,letterSpacing:'2px',lineHeight: '32px' }}>Download US Companies <img src={exportlistImg} /></h4>
                    </div>
                    <div className="col-md-6 dwnld-link mb-3" onClick={() => this.downloadCSV('all_competitors')} >
                      <h4 style={{ cursor: "pointer", fontSize:16,fontWeight:500,letterSpacing:'2px',lineHeight: '32px' }}>Download all Competitors <img src={exportlistImg} /></h4>
                    </div>
                    <div className="col-md-6 dwnld-link mb-3" onClick={() => this.downloadCSV('US_competitors')} >
                      <h4 style={{ cursor: "pointer", fontSize:16,fontWeight:500,letterSpacing:'2px',lineHeight: '32px' }}>Download US Competitors <img src={exportlistImg} /></h4>
                    </div>
                    <form style={{ display: "none" }} action={main_server + "/api/user/download"} method="post">
                      <input type="hidden" name="token" value={localStorage.jwtToken || Cookies.get('token')} />
                      <input type="hidden" name="filename" value={this.state.downloadFilename} />
                      <input type="submit" value="submit" id="csv-download-btn" />
                    </form>
                  </div>
                }
                <div className="row">
                  <div className="col-8 list-select">
                    <Select
                    placeholder="Select a free list"
                      value={this.state.selectedCompany}
                      onChange={this.handleChange}
                      options={groupedOptions}
                      formatGroupLabel={formatGroupLabel}
                      className='list-selected'
                    />
                  </div>
                  <div className="col-4" style={{ margin: "auto" }}>
                    <button className="btn exportBtn" style={{paddingLeft: 20,paddingRight:20}} onClick={this.checkMonthlyDownloadLimit}>Download</button>
                  </div>

                  {/* <div className="col-md-6" style={{ margin: "auto", paddingTop: '100px' }}>
                    <a href="https://buy.stripe.com/dR614ucqQ9TFewoeUU" target='_blank' className="btn btn-primary" >Download the Full Growjo 10,000 List</a>
                  </div> */}

                  <form style={{ display: "none" }} action={main_server + "/api/user/exportlist-download"} method="post">
                    <input type="hidden" name="token" value={localStorage.jwtToken || Cookies.get('token')} />
                    <input type="hidden" name="type" value={this.state.downloadExportListType} />
                    <input type="hidden" name="key" value={this.state.downloadExportListKey} />
                    <input type="hidden" name="name" value={this.state.downloadExportListName} />
                    <input type="submit" value="submit" id="exportlist-download-btn" />
                  </form>
                </div>

                <SweetAlert
                  warning
                  showCancel
                  confirmBtnText="Yes, download it!"
                  confirmBtnBsStyle="primary"
                  title="Are you sure?"
                  onConfirm={this.downloadFromDropdown}
                  onCancel={this.closeExportPopUp}
                  focusCancelBtn
                  show={this.state.showExportPopUp}
                >
                  {downloadConfirmationMsg}
                </SweetAlert>

                <SweetAlert
                  warning
                  confirmBtnText="Cancel"
                  confirmBtnBsStyle="primary"
                  title="Download Limit Reached!!"
                  onConfirm={this.closeExportErrorPopUp}
                  cancelBtnBsStyle="success"
                  cancelBtnText="Upgrade"
                  onCancel={this.upgradeBtn}
                  focusCancelBtn
                  showCancel
                  show={this.state.showExportErrorPopUp}
                >
                  Sorry! You have already reached your download limit for this month.
                </SweetAlert>

                {/* <select
                  value={this.state.selectedCompany}
                  onChange={e => this.setState({ selectedCompany: e.target.value, validationError: e.target.value === "" ? "You must select your favourite team" : "" })}
                >
                  <option value="">Download Company 
                  Data</option>
                  {
                    dropdownArray.map((data, index) => (
                      <option key={'data' + index} value={index}>{data.title}</option>
                    ))
                  }
                </select> */}
                {/* <div style={{ display: 'flex' }}>
                  <p>Growjo 10,000</p>
                  <img src={'/static/img/download.png'} style={{ width: 20, height: 20, marginLeft: 10 }} onClick={this.download}></img>
                </div>
                {
                  cities.map((city, index) => (
                    <div key={city + index} style={{ display: 'flex' }}>
                      <p>Fastest Growing {city} Companies</p>
                      <img src={'/static/img/link.png'} style={{ width: 20, height: 20, marginLeft: 10 }} onClick={() => this.props.history.push(`/city/${city}`)} />
                      <img src={'/static/img/download.png'} style={{ width: 20, height: 20, marginLeft: 10 }} onClick={() => this.download_city(city)}></img>
                    </div>
                  ))
                }
                <div style={{ display: 'flex' }}>
                  <p>Fastest Growing Fintech Companies</p>
                  <img src={'/static/img/link.png'} style={{ width: 20, height: 20, marginLeft: 10 }} onClick={() => this.props.history.push(`/industry/Fintech`)} />
                  <img src={'/static/img/download.png'} style={{ width: 20, height: 20, marginLeft: 10 }} onClick={() => this.download_city('Fintech')}></img>
                </div>
                <div style={{ display: 'flex' }}>
                  <p>Fastest Growing Cannabis Companies</p>
                  <img src={'/static/img/link.png'} style={{ width: 20, height: 20, marginLeft: 10 }} onClick={() => this.props.history.push(`/industry/Cannabis`)} />
                  <img src={'/static/img/download.png'} style={{ width: 20, height: 20, marginLeft: 10 }} onClick={() => this.download_city('Cannabis')}></img>
                </div> */}
              </div>
              
              {/* <Lead411Ad /> */}
            </div>
            <div className="row col-md-12  d-flex justify-content-between align-items-center" style={{paddingTop: '40px'}}>
              <h4 id='funding-rounds' >Premium Lists For Sale</h4>
              <div className=" text-right ml-auto" style={{ marginBottom:6}}>
                <h3>
                  <Link to="/search" className='adv-search-btn btn'><i className='fa fa-cog'></i> Advanced Search</Link>
                </h3>
              </div>
            </div>
            <table className="table welcome-table" style={{ fontSize: '13px', fontWeight: 'normal', fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif' }}>
              <thead>
                <tr style={{ backgroundColor: 'rgba(245, 245, 250, 0.7)', color: '#000',fontSize: 16,borderRadius:16,fontWeight:700 }}>
                  <td scope="col">List Name</td>
                  <td scope="col">Description</td>
                  <td scope="col">Count</td>
                  <td scope="col">Price</td>
                </tr>
              </thead>
              <tbody>
                {
                  premiumListData.map((list, index) => (
                    <tr key={index + 'premiumList'}>
                      <td>{list.name}</td>
                      <td>{list.description}</td>
                      <td>{list.count}</td>
                      <td>
                        <span style={{paddingRight: '10px'}}>{list.amount}</span>
                        <a href={list.paymentLink} target='_blank' className="btn exportBtn" style={{paddingLeft: 20,paddingRight:20}} >Buy Now!</a>
                      </td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
          </CardBody>
        </Card>
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          style={customStyles}
          contentLabel="Example Modal"
          shouldFocusAfterRender={true}
          shouldCloseOnOverlayClick={true}
          ariaHideApp={true}
        >
          <div style={{ backgroundColor: "white", fontSize: 15, textAlign: "center" }}>
            <h5>For Contact at these companies with emails and direct phone numbers please visit <a href="https://www.lead411.com" target="_blank">Lead411</a></h5>
            <div style={{ display: "block", marginTop: 28 }}>
              <ClipLoader
                sizeUnit={"px"}
                size={40}
                color={'grey'}
                loading={this.state.downloading}
                display={'block'}
              />
            </div>
          </div>
        </Modal>
      </div >
    );
  }
}
Home.contextType = AppContext;
export default Home;


function newFunction() {
  return {};
}




// WEBPACK FOOTER //
// ./client/src/views/Welcome/index.js